import { ContactId } from '../../types/contact-interface'

export const parseContactId = (rawContact: string | string[] | undefined): ContactId => {
  const parsed = parseInt(rawContact as string, 10)
  return isNaN(parsed) ? 0 : parsed
}
